const STATE = {
    activeVariantForHer: null,
    activeGoldForHer: null,
    activeSizeForHer: null,
    activeImageForHer: null,
    activeVariantForHim: null,
    activeGoldForHim: null,
    activeSizeForHim: null,
    activeImageForHim: null,
};

const forHerTriggerVariants = document.querySelectorAll('.js-trigger-variant-for-her');
const forHerTriggerGolds = document.querySelectorAll('.js-trigger-gold-for-her');

const forHerTriggerSizes = document.querySelectorAll('.js-trigger-size-for-her');

const forHerImages = [...document.querySelectorAll('.js-image-for-her')];

const forHimTriggerVariants = document.querySelectorAll('.js-trigger-variant-for-him');
const forHimTriggerGolds = document.querySelectorAll('.js-trigger-gold-for-him');

const forHimTriggerSizes = document.querySelectorAll('.js-trigger-size-for-him');

const forHimImages = [...document.querySelectorAll('.js-image-for-him')];

const activateDefaults = () => {
    [STATE.activeVariantForHer, STATE.activeGoldForHer, STATE.activeSizeForHer] = [
        forHerTriggerVariants[4],
        forHerTriggerGolds[0],
        forHerTriggerSizes[0],
    ];
    STATE.activeVariantForHer.classList.add('is-active');
    STATE.activeGoldForHer.classList.add('is-active');
    STATE.activeSizeForHer.classList.add('is-active');

    [STATE.activeVariantForHim, STATE.activeGoldForHim, STATE.activeSizeForHim] = [
        forHimTriggerVariants[3],
        forHimTriggerGolds[0],
        forHimTriggerSizes[1],
    ];
    STATE.activeVariantForHim.classList.add('is-active');
    STATE.activeGoldForHim.classList.add('is-active');
    STATE.activeSizeForHim.classList.add('is-active');
};

const activateImageForHer = () => {
    const imgName = `${STATE.activeVariantForHer.dataset.id}-${STATE.activeGoldForHer.dataset.id}-her`;

    STATE.activeImageForHer?.classList.remove('is-active');
    STATE.activeImageForHer = forHerImages.find((el) => el.dataset.id === imgName);
    STATE.activeImageForHer?.classList.add('is-active');

    if (STATE.activeSizeForHer?.dataset.makeSmaller) {
        STATE.activeImageForHer.classList.add('is-animated');
    } else {
        STATE.activeImageForHer.classList.remove('is-animated');
    }
};

const activateImageForHim = () => {
    const imgName = `${STATE.activeVariantForHim.dataset.id}-${STATE.activeGoldForHim.dataset.id}-him`;

    STATE.activeImageForHim?.classList.remove('is-active');
    STATE.activeImageForHim = forHimImages.find((el) => el.dataset.id === imgName);
    STATE.activeImageForHim?.classList.add('is-active');

    if (STATE.activeSizeForHim?.dataset.makeSmaller) {
        STATE.activeImageForHim.classList.add('is-animated');
    } else {
        STATE.activeImageForHim.classList.remove('is-animated');
    }
};

const listener = () => {
    forHerTriggerVariants.forEach((el) => {
        el.addEventListener('click', (e) => {
            e.preventDefault();

            STATE.activeVariantForHer?.classList.remove('is-active');
            STATE.activeVariantForHer = el;
            STATE.activeVariantForHer.classList.add('is-active');
            activateImageForHer();
        });
    });

    forHerTriggerGolds.forEach((el) => {
        el.addEventListener('click', (e) => {
            e.preventDefault();

            STATE.activeGoldForHer?.classList.remove('is-active');
            STATE.activeGoldForHer = el;
            STATE.activeGoldForHer.classList.add('is-active');
            activateImageForHer();
        });
    });

    forHerTriggerSizes.forEach((el) => {
        el.addEventListener('click', (e) => {
            e.preventDefault();

            STATE.activeSizeForHer?.classList.remove('is-active');
            STATE.activeSizeForHer = el;
            STATE.activeSizeForHer.classList.add('is-active');
            activateImageForHer();
        });
    });

    forHimTriggerVariants.forEach((el) => {
        el.addEventListener('click', (e) => {
            e.preventDefault();

            STATE.activeVariantForHim?.classList.remove('is-active');
            STATE.activeVariantForHim = el;
            STATE.activeVariantForHim.classList.add('is-active');
            activateImageForHim();
        });
    });

    forHimTriggerGolds.forEach((el) => {
        el.addEventListener('click', (e) => {
            e.preventDefault();

            STATE.activeGoldForHim?.classList.remove('is-active');
            STATE.activeGoldForHim = el;
            STATE.activeGoldForHim.classList.add('is-active');
            activateImageForHim();
        });
    });

    forHimTriggerSizes.forEach((el) => {
        el.addEventListener('click', (e) => {
            e.preventDefault();

            STATE.activeSizeForHim?.classList.remove('is-active');
            STATE.activeSizeForHim = el;
            STATE.activeSizeForHim.classList.add('is-active');
            activateImageForHim();
        });
    });
};

window.addEventListener('DOMContentLoaded', () => {
    activateDefaults();
    activateImageForHer();
    activateImageForHim();

    listener();
});
